export default {"src":"/_next/static/media/icon.9a256c3e.svg","height":89,"width":87,"blurWidth":0,"blurHeight":0};